import { MutableRefObject, ReactElement } from 'react';

import './style.sass';

import { TableRowProps } from './TableRow';

type Props = {
    className?: string,
    headerClassName?: string,
    headerCellClassName?: string,
    headerDataClassName?: string,
    bodyClassName?: string,
    columns: string[],
    children: ReactElement<TableRowProps> | Array<ReactElement<TableRowProps>>,
    tableRef?: MutableRefObject<HTMLDivElement>,
};

export const Table = ({
    className,
    headerClassName,
    headerCellClassName,
    headerDataClassName,
    bodyClassName,
    columns,
    children,
    tableRef,
}: Props) => {
    const tableClass = `table ${className ? className : ''}`;
    const tableHeaderClass = `table__header ${headerClassName ? headerClassName : ''}`;
    const headerThClass = `table__header-cell ${headerCellClassName} ${
        headerDataClassName
            ? `${headerDataClassName}`
            : 'p2-regular grey-1'
    }`;

    const tableBodyClass = `table__body ${bodyClassName ? bodyClassName : ''}`;

    return (
        <div className={tableClass} ref={tableRef}>
            <div className={tableHeaderClass}>
                {columns.map((item, index) => (
                    <div
                        key={`${index}_th-${item}`}
                        className={headerThClass}
                    >
                        {item}
                    </div>
                ))}
            </div>

            <div className={tableBodyClass}>
                {children}
            </div>
        </div>
    );
};
